export function isSizeValid(file: Blob, maxSize: number) {
  return Number.isInteger(maxSize) && file.size <= maxSize;
}
